import { render } from "./add.vue?vue&type=template&id=570fae94&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"

import "./add.vue?vue&type=style&index=0&id=570fae94&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570fae94"]])

export default __exports__